import { html, LitElement } from "lit-element";
import { connect } from "pwa-helpers/connect-mixin";
import { store } from "@stofloos/stores/store";
import { InputSimpleStyle } from "@stofloos/components/atoms/inputs/input-simple";
import { InputCheckboxStyle } from "@stofloos/components/atoms/inputs/input-checkbox";

import { LayoutFlex } from "@stofloos/globals/styles/layout-flex";

import { style } from "./style";
import { toggleOrderBy } from "@stofloos/actions/requests";
import { localize } from "@stofloos/actions/localize";

class FilterSortBy extends connect(store)(LitElement) {
	constructor() {
		super();
		this.visible = false;
	}

	static get styles() {
		return [InputSimpleStyle, InputCheckboxStyle, LayoutFlex, style];
	}

	static get properties() {
		return {
			column: Object,
			requestId: String,
			direction: String,
			visible: Boolean
		};
	}

	stateChanged(state) {
		if(state.requests[this.requestId] && state.requests[this.requestId].orderBy) {
			this.direction = state.requests[this.requestId].orderBy.direction
		}
	}

	render() {
		return html`
			<div class="layout horizontal label" @click="${this.orderBy}"><span class="flex">${localize([this.requestId+"::"+this.column.name, "properties::"+this.column.name])}</span><sw-icon icon="chevron-${this.direction === 'asc' ?  "up" : "down"}"></sw-icon></div>
		`;
	}

	orderBy(e, direction) {
		store.dispatch(toggleOrderBy(this.requestId, this.column.name, null, true));
	}

}

window.customElements.define("filter-sortby", FilterSortBy);
